import { Search } from 'lucide-react';
import * as React from 'react';
import { Button, Input } from '@payment-plan/ui';
import type { SeparacionEstado } from '../../../types/consultas';
import { NATIVE_SELECT_CLASS, TOUCH_INPUT_CLASS } from '../../separations/components/field-styles';
import { SEPARACION_ESTADOS } from '../estados';

interface SearchBarProps {
  onBuscar: (termino: string) => void;
  estado: SeparacionEstado | '';
  onEstado: (estado: SeparacionEstado | '') => void;
}

/**
 * Búsqueda libre (separante, unidad o consecutivo) con envío explícito —Enter o «Buscar»— para no
 * consultar por cada tecla en tablet, y filtro de estado con `<select>` nativo (L-007).
 */
export function SearchBar({ onBuscar, estado, onEstado }: SearchBarProps): React.JSX.Element {
  const [texto, setTexto] = React.useState('');

  return (
    <div className="grid gap-3 lg:grid-cols-[minmax(0,1fr)_14rem] lg:items-end">
      <form
        role="search"
        className="flex items-end gap-2"
        onSubmit={(event) => {
          event.preventDefault();
          onBuscar(texto.trim());
        }}
      >
        <div className="min-w-0 flex-1 space-y-1.5">
          <label htmlFor="consulta-busqueda" className="text-sm font-medium text-foreground">
            Buscar separación
          </label>
          <Input
            id="consulta-busqueda"
            type="search"
            placeholder="Separante, unidad o consecutivo"
            value={texto}
            maxLength={100}
            onChange={(event) => setTexto(event.target.value)}
            className={TOUCH_INPUT_CLASS}
          />
        </div>
        <Button type="submit" size="lg" className="px-4">
          <Search className="h-4 w-4" aria-hidden="true" />
          Buscar
        </Button>
      </form>
      <div className="space-y-1.5">
        <label htmlFor="consulta-estado" className="text-sm font-medium text-foreground">
          Estado
        </label>
        <select
          id="consulta-estado"
          value={estado}
          onChange={(event) => onEstado(event.target.value as SeparacionEstado | '')}
          className={NATIVE_SELECT_CLASS}
        >
          <option value="">Todos los estados</option>
          {SEPARACION_ESTADOS.map((e) => (
            <option key={e.valor} value={e.valor}>
              {e.etiqueta}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
